import useMapStore from "@/store/mapStore";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import { Button } from "./ui/button";

const StopsToggle = () => {
  const stops = useMapStore((state) => state.stops);
  const activeStop = useMapStore((state) => state.activeStop);
  const map = useMapStore((state) => state.map);
  const haveRouteDetails = useMapStore((state) => state.haveRouteDetails);
  const setActiveStop = useMapStore((state) => state.setActiveStop);

  const setActiveStopHandler = (stop: "next" | "previous") => {
    const newActiveStop = stop === "next" ? activeStop + 1 : activeStop - 1;
    console.log("set active stop", newActiveStop);
    setActiveStop(newActiveStop);
    map.setStop(newActiveStop);
    if (stops && stops[newActiveStop]?.feature?.id && !haveRouteDetails) {
      map.centerToFeature(stops[newActiveStop].feature!.id);
    }
  };

  if (stops.length <= 2) return null;
  return (
    <div className="absolute top-6 z-10 flex items-center gap-3 group-data-[dir=ltr]:left-6 group-data-[dir=rtl]:right-6 group-data-[dir=ltr]:lg:left-10 group-data-[dir=rtl]:lg:right-10">
      <Button
        className="h-8 w-8 rounded-full border-primary text-base text-primary hover:border-primary/60 hover:text-primary/60 lg:h-10 lg:w-10 lg:text-2xl"
        variant={"outline"}
        size={"icon"}
        disabled={activeStop === 0}
        onClick={() => setActiveStopHandler("previous")}
      >
        <FaAngleLeft />
      </Button>
      <div className="text-sm lg:text-base">
        {activeStop + 1} / {stops.length}
      </div>
      <Button
        className="h-8 w-8 rounded-full border-primary text-base text-primary hover:border-primary/60 hover:text-primary/60 lg:h-10 lg:w-10 lg:text-2xl"
        variant={"outline"}
        size={"icon"}
        disabled={activeStop === stops.length - 1}
        onClick={() => setActiveStopHandler("next")}
      >
        <FaAngleRight />
      </Button>
    </div>
  );
};

export default StopsToggle;
